import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between items-center w-full" }
const _hoisted_2 = { class: "flex flex-row gap-1 items-center" }

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";

import { RegisterTheme } from "@/common/themes";
import { iconMenu, svgIcon } from "@/common/components";

import MethodQuestionForm from "@/components/tabs/method-question.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'question',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const route = useRoute();

const accountId = computed(() => String(route.params.id));
const groupId = computed(() => String(route.params.group));

const menuTabs = computed(() => [
  {
    key: "edit",
    icon: "home-line",
    label: t("common.labels.group"),
  },
  {
    key: "field",
    icon: "field",
    label: t("common.labels.fields"),
  },
  {
    key: "method",
    icon: "method",
    label: t("common.labels.methods"),
  },
  {
    key: "question",
    icon: "form",
    label: t("common.labels.questions"),
  },
]);

function back() {
  router.push(`/${accountId.value}/register/method`);
}

function goToTab(tab: string) {
  router.push(`/${accountId.value}/register/method/${groupId.value}/${tab}`);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RegisterTheme), { "tab-active": "method" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(svgIcon), {
            icon: "method",
            size: "2rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("common.labels.edit", { concat: _unref(t)("common.labels.method") })), 1)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-back btn-sm",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "close",
            size: "1.25rem"
          })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_unref(iconMenu), {
        tabs: menuTabs.value,
        active: "question",
        onSelected: _cache[1] || (_cache[1] = ($event: any) => (goToTab($event)))
      }, {
        content: _withCtx(() => [
          _createVNode(MethodQuestionForm, {
            "account-id": accountId.value,
            "group-id": groupId.value,
            remove: ['PHOTO']
          }, null, 8, ["account-id", "group-id"])
        ]),
        _: 1
      }, 8, ["tabs"])
    ]),
    _: 1
  }))
}
}

})